import React from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';

import betterBusinessBureauJpg from 'dpl/assets/breeder_join/better_business_bureau.jpg';
import facebookJpg from 'dpl/assets/breeder_join/facebook.jpg';

export default function TrustSection() {
  const {
    trustItems: { betterBusinessBureauUrl, facebookLikesCount, facebookUrl }
  } = useSelector(({ server }) => ({ trustItems: server.trustItems }));

  return (
    <div className="TrustSection container tc">
      <div className="flex-l align-items-center justify-around">
        <div className="TrustSection__item mb8 mb0-lg order-lg-1 flex-l justify-center">
          <a
            className="inline-flex align-items-center fw-medium"
            href={facebookUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="mr2">
              <SmartImage height="40px" lazy src={facebookJpg} width="40px" />
            </div>
            <span className="f2 f3-md">Good Breeder Center</span>
            <span className="TrustSection__facebookCount pv1 ph1 br1 ml3 relative bg-black-70 white f2">
              {facebookLikesCount}
            </span>
          </a>
        </div>

        <div className="TrustSection__item order-3 flex-l justify-center">
          <a
            href={betterBusinessBureauUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <SmartImage
              height="65px"
              lazy
              src={betterBusinessBureauJpg}
              width="161px"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
